import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileStickyCallButton } from "./MobileStickyCallButton";
import { ExitIntentModal } from "./ExitIntentModal";
import { CalculatorSlideOut } from "./CalculatorSlideOut";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-[100dvh] flex flex-col bg-background text-foreground selection:bg-primary/20 selection:text-primary">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:font-semibold focus:text-white focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1 focus:outline-none">
        {children}
      </main>
      <Footer />
      <CalculatorSlideOut />
      <MobileStickyCallButton />
      <ExitIntentModal />
    </div>
  );
}
